/** The cockpit every client lands on. */
export const COCKPIT_PATH = "/main/cockpit";

/** The IRES Admin cockpit, shown to the admin portal client instead of the normal cockpit. */
export const ADMIN_COCKPIT_PATH = "/main/admin/cockpit";

/**
 * Where "the cockpit" is for the current client: the admin cockpit for the admin portal client
 * (`officeAdminClientIds`), the normal cockpit for everyone else.
 *
 * Takes the portal flag as an argument instead of reading it, so this module stays import-free and a
 * spec can load it without the router's import cycle.
 */
export function getCockpitPath(isOfficeAdminPortalClient: boolean): string {
  return isOfficeAdminPortalClient ? ADMIN_COCKPIT_PATH : COCKPIT_PATH;
}
